import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import {
  ContactCard,
  ContactHeader,
  AddressContainer,
} from './ContactUs.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';

const ContactUs = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Contact Us"
        description="Contact Us Yoda Safety Services"
      />
      <SideContainerComponent />
      <MainSection>
        <h2>Contact Us</h2>
        <AddressContainer>
          <address>
            825 Ostrea Lake Road, Ostrea Lake Nova Scotia B0J 2L0
          </address>
          <p>
            <strong>Hours: </strong>Monday - Friday, 9 AM - 5 PM
          </p>
        </AddressContainer>
        <ContactCard delay="0.4s">
          <ContactHeader>Jim Benoit</ContactHeader>
          <p className="italics">
            President/CEO ASA/CSO/Auditor/Trainer/Site Inspector/Health & Safety
            Program and Course Development
          </p>
          <p>
            <strong>Email:</strong> jbenoit.yoda@outlook.com
          </p>
          <p>
            <strong>Phone:</strong>902-478-1972
          </p>
        </ContactCard>
        <ContactCard delay="0.5s">
          <ContactHeader>Helen Benoit</ContactHeader>
          <p className="italics">Office Admin</p>
          <p>
            <strong>Email:</strong> hbenoit.yoda@outlook.com
          </p>
          <p>
            <strong>Phone:</strong> 902-802-9716
          </p>
        </ContactCard>
        <ContactCard delay="0.6s">
          <ContactHeader>Victoria Benoit</ContactHeader>
          <p className="italics">Web Developer</p>
          <p>
            <strong>Email:</strong> vrose834@gmail.com
          </p>
          <p className="m1B">
            <strong>Phone:</strong> 902-817-1001
          </p>
          <a href="https://reactportfolio-olio.onrender.com">Portfolio</a>
        </ContactCard>
      </MainSection>
    </MainContentContainer>
  );
};

export default ContactUs;
